<template>
  <div class="form-list">
    <div class="table-title table-title-top">{{ details.request_administrator_id ? '申请' : '修改人' }}信息</div>
    <el-form
      ref="form"
      :model="details"
      label-position="right"
      label-width="130px"
      class="form"
    >
      <template v-if="details.request_administrator_id">
        <el-form-item label="申请时间">
          {{ details.add_time | timeToYmdHi }}
        </el-form-item>

        <el-form-item label="申请者">
          <v-avatar-nickname
            :value="details.request_administrator_avatar"
            :nickname="details.request_administrator_nickname"
            :is-center="false"
          />
        </el-form-item>

        <el-form-item label="申请门店">{{ details.request_store_name }}</el-form-item>

        <el-form-item label="申请操作" prop="id_number">
          <strong v-for="updateType in findStudentUpdateType(details.update_type)" :key="`request-${updateType.value}`">修改{{ updateType.name }}</strong>
        </el-form-item>

        <el-form-item label="申请原因">
          <span v-if="details.reason" class="danger-color">{{ details.reason }}</span>
          <span v-else class="info-color">未填写</span>
        </el-form-item>
        <el-form-item label="原因截图">
          <v-img v-if="details.reason_img" class="table-cover-phone" :value="details.reason_img"/>
          <span v-else class="info-color">未上传</span>
        </el-form-item>
      </template>
      <template v-else>
        <template v-if="details.administrator_id">
          <el-form-item label="修改时间">
            {{ details.add_time | timeToYmdHi }}
          </el-form-item>

          <el-form-item label="修改者">
            <v-avatar-nickname
              :value="details.add_administrator_avatar"
              :nickname="details.add_administrator_nickname"
              :is-center="false"
            />
          </el-form-item>

          <el-form-item label="修改者所在门店">
            <template v-if="details.add_store_name">{{ details.add_store_name }}</template>
            <span v-else class="info-color">未知</span>
          </el-form-item>

          <el-form-item label="操作类型" prop="id_number">
            <strong v-for="updateType in findStudentUpdateType(details.update_type)" :key="`detail-${updateType.value}`">修改{{ updateType.name }}</strong>
          </el-form-item>

          <el-form-item label="修改原因">
            <span v-if="details.reason" class="danger-color">{{ details.reason }}</span>
            <span v-else class="info-color">未填写</span>
          </el-form-item>
          <el-form-item label="原因截图">
            <v-img v-if="details.reason_img" class="table-cover-phone" :value="details.reason_img"/>
            <span v-else class="info-color">未上传</span>
          </el-form-item>
        </template>
        <el-form-item v-else label="修改人">学员本人</el-form-item>

      </template>

      <div class="table-title">学员资料</div>

      <el-form-item label="学员 ID">
        {{ details.student_id }}
        <router-link :to="RouteConfig.studentDetail.to(details.student_id)" class="active-link">
          查看学员主页
        </router-link>
      </el-form-item>
      <el-form-item label="学员当前姓名">
        {{ details.current_student_name }}
      </el-form-item>

      <el-form-item label="学员当前自拍">
        <v-avatar :value="details.current_selfie" :size="100"/>
      </el-form-item>

      <el-form-item label="注册时间">
        {{ details.register_time | timeToYmdHi }}
      </el-form-item>
      <el-form-item label="注册来源">
        {{ details.register_store_name || '小程序' }}
      </el-form-item>
      <el-form-item label="拥有课卡数量" prop="id_number">
        {{ details.card_count || 0 }}
      </el-form-item>

      <div class="table-title">修改内容</div>

      <el-form-item v-if="details.old_student_name || details.student_name" label="姓名">
        <template v-if="details.old_student_name !== details.student_name">
          <span class="user-select">{{ details.old_student_name }}</span>
          <v-icon name="arrow-right"/>
          <span class="primary-color user-select">{{ details.student_name }}</span>
        </template>
        <template v-else>{{ details.student_name }}</template>
      </el-form-item>

      <el-form-item v-if="details.old_nickname || details.nickname" label="昵称">
        <template v-if="details.old_nickname !== details.nickname">
          <span class="user-select">{{ details.old_nickname }}</span>
          <v-icon name="arrow-right"/>
          <span class="primary-color user-select">{{ details.nickname }}</span>
        </template>
        <template v-else>{{ details.nickname }}</template>
      </el-form-item>

      <el-form-item v-if="details.old_selfie || details.selfie" label="真人自拍">
        <div v-if="details.old_selfie !== details.selfie" class="flex-align-center">
          <v-avatar :value="details.old_selfie" :size="100"/>
          <v-icon name="arrow-right"/>
          <v-avatar :value="details.selfie" :size="100"/>
        </div>
        <v-avatar v-else :value="details.selfie" :size="100"/>
      </el-form-item>

      <el-form-item v-if="details.old_avatar || details.avatar" label="小程序头像">
        <div v-if="details.old_avatar !== details.avatar" class="flex-align-center">
          <v-avatar :value="details.old_avatar" :size="100"/>
          <v-icon name="arrow-right"/>
          <v-avatar :value="details.avatar" :size="100"/>
        </div>
        <v-avatar v-else :value="details.avatar" :size="100"/>
      </el-form-item>

      <el-form-item v-if="details.old_phone || details.phone" label="手机号">
        <template v-if="details.old_phone !== details.phone">
          <span class="user-select">{{ details.old_phone }}</span>
          <v-icon name="arrow-right"/>
          <span class="primary-color user-select">{{ details.phone }}</span>
        </template>
        <template v-else>{{ details.phone }}</template>
      </el-form-item>

      <el-form-item v-if="details.old_gender || details.gender" label="性别">
        <template v-if="details.old_gender !== details.gender">
          <span class="user-select">{{ getGenderName(details.old_gender) }}</span>
          <v-icon name="arrow-right"/>
          <span class="primary-color user-select">{{ getGenderName(details.gender) }}</span>
        </template>
        <template v-else>{{ getGenderName(details.gender) }}</template>
      </el-form-item>

      <el-form-item v-if="details.old_birthday || details.birthday" label="生日">
        <template v-if="details.old_birthday !== details.birthday">
          <span v-if="details.old_birthday" class="user-select">{{ details.old_birthday | timeToYmd }}</span>
          <span v-else class="info-color">未填写</span>
          <v-icon name="arrow-right"/>
          <span v-if="details.birthday" class="primary-color user-select">{{ details.birthday | timeToYmd }}</span>
          <span v-else class="info-color">未填写</span>
        </template>
        <template v-else>
          <template v-if="details.birthday">{{ details.birthday | timeToYmd }}</template>
          <span v-else class="info-color">未填写</span>
        </template>
      </el-form-item>

      <el-form-item v-if="details.old_id_number || details.id_number" label="实名证件号" prop="id_number">
        <template v-if="details.old_id_number !== details.id_number">
          <span v-if="details.old_id_number" class="user-select">{{ details.old_id_number }}</span>
          <span v-else class="info-color">未填写</span>
          <v-icon name="arrow-right"/>
          <span v-if="details.id_number" class="primary-color user-select">{{ details.id_number }}</span>
          <span v-else class="info-color">未填写</span>
        </template>
        <template v-else>
          <span v-if="details.id_number">{{ details.id_number }}</span>
          <span v-else class="info-color">未填写</span>
        </template>
      </el-form-item>

      <el-form-item v-if="details.old_card_number || details.card_number" label="会员卡号">
        <template v-if="details.old_card_number !== details.card_number">
          <span class="user-select">{{ details.old_card_number }}</span>
          <v-icon name="arrow-right"/>
          <span class="primary-color user-select">{{ details.card_number }}</span>
        </template>
        <template v-else>{{ details.card_number }}</template>
      </el-form-item>

      <el-form-item v-if="details.old_used_card_id || details.used_card_id" label="默认支付课卡">
        <template v-if="details.old_used_card_id !== details.used_card_id">
          <router-link v-if="details.old_used_card_id" :to="RouteConfig.cardDetail.to(details.old_used_card_id)" class="active-link-normal">
            {{ details.old_used_card_name }} No.{{ details.old_used_card_id }}
          </router-link>
          <span v-else class="info-color">未选择</span>
          <v-icon name="arrow-right"/>
          <router-link v-if="details.used_card_id" :to="RouteConfig.cardDetail.to(details.used_card_id)" class="active-link">
            {{ details.used_card_name }} No.{{ details.used_card_id }}
          </router-link>
          <span v-else class="info-color">未选择</span>
        </template>
        <router-link v-else :to="RouteConfig.cardDetail.to(details.old_used_card_id)" class="active-link-normal">
          {{ details.old_used_card_name }} No.{{ details.old_used_card_id }}
        </router-link>
      </el-form-item>

      <template v-if="details.review_administrator_id">
        <div class="table-title">审核信息</div>

        <el-form-item v-if="canViewReviewInfo" label="审核时间">
          {{ details.review_time | timeToYmdHi }}
        </el-form-item>

        <el-form-item v-if="canViewReviewInfo" label="审核人">
          <v-avatar-nickname
            :value="details.review_administrator_avatar"
            :nickname="details.review_administrator_nickname"
            :is-center="false"
          />
        </el-form-item>

        <el-form-item v-if="isAdministrator" label="审核备注">
          <span v-if="details.remark" class="danger-color">{{ details.remark }}</span>
          <span v-else class="info-color">未填写</span>
        </el-form-item>

        <el-form-item v-if="isAdministrator" label="备注截图">
          <v-img v-if="details.remark_img" class="table-cover-phone" :value="details.remark_img"/>
          <span v-else class="info-color">未上传</span>
        </el-form-item>
      </template>

      <el-form-item>
        <el-button @click="RouteConfig.studentUpdateRequestList.back">返回</el-button>
      </el-form-item>

    </el-form>
  </div>
</template>

<script>
import RouteConfig from '@/router/config';
import { show } from '@/api/student-update-record';
import { mapGetters } from 'vuex';
import { applyStates } from '@/enums/applyStates';
import { findStudentUpdateType } from '@/enums/studentUpdateTypes';

export default {
  name: RouteConfig.studentUpdateRecordDetail.name,
  data: () => ({
    RouteConfig,
    isLoading: false,
    isLoadingError: false,
    isExamining: false,
    isRevoking: false,
    isReject: 0,
    applyStates,
    details: {
      add_time: 0,
      update_time: 0,
      add_administrator_id: 0,
      update_administrator_id: 0,
      add_store_id: 0,
      student_id: 0,
      update_type: 0,
      reason: '',
      reason_img: '',
      phone: 0,
      student_name: '',
      nickname: '',
      selfie: '',
      avatar: '',
      card_number: '',
      used_card_id: 0,
      used_card_name: '',
      gender: 0,
      birthday: 0,
      id_number: '',
      old_phone: '',
      old_student_name: '',
      old_nickname: '',
      old_selfie: '',
      old_avatar: '',
      old_card_number: '',
      old_used_card_id: '',
      old_used_card_name: '',
      old_gender: '',
      old_birthday: '',
      old_id_number: '',

      register_time: 0,
      register_store_name: '',
      current_student_name: '',
      current_selfie: '',
      card_count: 0,
      add_store_name: '',

      administrator_id: 0,
      add_administrator_nickname: '',
      add_administrator_avatar: '',

      request_administrator_id: 0,
      request_administrator_nickname: '',
      request_administrator_avatar: '',
      request_store_name: '',

      review_time: 0,
      review_administrator_id: 0,
      review_administrator_nickname: '',
      review_administrator_avatar: '',

      remark: '',
      remark_img: '',
      store_id: 0,
    },
  }),

  computed: {
    ...mapGetters(['isAdministrator', 'userStoreId']),
    canViewReviewInfo() {
      return this.isAdministrator || this.userStoreId === this.details.store_id;
    },
    id() {
      return +this.$route.params.id || 0;
    },
  },

  beforeMount() {
    this.show();
  },

  methods: {
    findStudentUpdateType,
    getGenderName(gender) {
      const genders = {
        0: '保密',
        1: '男',
        2: '女',
      };
      return genders[gender] || '保密';
    },

    async show() {
      if (this.isLoading) return;

      this.isLoading = true;
      this.isLoadingError = false;
      const { isError, data } = await show(this.id);
      if (isError) {
        this.isLoading = false;
        this.isLoadingError = true;
        return;
      }

      const { details } = this;
      const updateData = {};
      Object.keys(data).forEach(key => {
        if (key in details) updateData[key] = data[key];
      });
      Object.assign(details, updateData);
      this.isLoading = false;
    },
  },
};
</script>
<style src="./update-request-detail.css" scoped/>
